import React, { useState, useEffect } from 'react';

interface SpeedAlarmProps {
  alarm: any; // Adapter le type en fonction de votre structure d'alarme
  onChange: (newMetrics: any) => void; // Fonction de rappel pour mettre à jour l'état du composant parent
}

const SpeedAlarm: React.FC<SpeedAlarmProps> = ({ alarm, onChange }) => {
  const [speed, setSpeed] = useState<string>("80");

  useEffect(() => {
    // console.log("alarm", alarm);
    if (alarm !== "") {
      setSpeed(alarm.max_speed);
    } else {
      setSpeed("80");
    }
  }, [alarm]);

 const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
   const value = event.target.value;
 
   // Autoriser l'effacement
   if (value === "") {
     setSpeed("");
     onChange({ ...alarm, type: "SpeedAlarm", max_speed: "" });
     return;
   }
 
   // Vérifier si c'est un nombre valide
   const numericValue = Number(value);
 
   // Bloquer si ce n'est pas un nombre ou hors limites
   if (!isNaN(numericValue) && numericValue >= 0 && numericValue <= 400) {
     setSpeed(value);
     onChange({ ...alarm, type: "SpeedAlarm", max_speed: numericValue });
   }
 };
 
  return (
    <div className="col-md-2 col-sm-4" style={{ marginTop: "2px" }}>
      <div className="input-group input-group-sm">
        <input
          className="form-control"
          name="Speeding"
          value={speed}
          type="number"
          min={0}
          max={400}
          placeholder="Speed"
          onChange={handleInputChange}
        />
        <span className="input-group-text">Km/h</span>
      </div>
    </div>
  );
};

export default SpeedAlarm;
